var path = '/templates/zenclerk_s/layout/main.html';
var html = "<div class=main><div zcs-hide-when-oem><zcs-notification-alert project=project></zcs-notification-alert></div><div ui-view=mainContent autoscroll=true></div></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/zenclerk_s_modules/zenclerk_s/layout/main.html
// module id = 1370
// module chunks = 0